// extracted by mini-css-extract-plugin
export var container = "_kj-0";
export var dotAnimation = "_kj-2";
export var dotsLoading = "_kj-1";